export const body = ({ theme: { colors } }) => ({
    padding: '40px 30px 64px',
    borderBottom: `1px solid ${colors.blueGrey1}`,
});
